import {
  GetSecretValueCommand,
  SecretsManagerClient,
} from '@aws-sdk/client-secrets-manager'
import { ConfigurationService } from '~/core/configuration/server/service'
import { Toolbox } from '~/plugins/toolbox/shared'
import { SecretsManagerProvider } from './provider'

export class SecretsManagerProviderAws extends SecretsManagerProvider {
  private client: SecretsManagerClient
  private region: string

  constructor() {
    super()
    this.initialise()
  }

  private async initialise() {
    const isProduction = ConfigurationService.isProduction()

    if (!isProduction) {
      console.info(`Skipped AWS Secrets Manager initialise in development.`)
      return
    }

    this.region = process.env.SERVER_SECRETS_MANAGER_AWS_REGION

    if (Toolbox.Utility.isNull(this.region)) {
      this.region = 'eu-west-2'
    }

    try {
      const accessKey = process.env.SERVER_SECRETS_MANAGER_AWS_ACCESS_KEY

      const secretKey = process.env.SERVER_SECRETS_MANAGER_AWS_SECRET_KEY

      if (!accessKey && !secretKey) {
        throw new Error(
          'Set SERVER_SECRETS_MANAGER_AWS_ACCESS_KEY && SERVER_SECRETS_MANAGER_AWS_SECRET_KEY in your .env to activate',
        )
      }

      if (!accessKey) {
        throw new Error(
          'Set SERVER_SECRETS_MANAGER_AWS_ACCESS_KEY in your .env to activate',
        )
      }

      if (!secretKey) {
        throw new Error(
          'Set SERVER_SECRETS_MANAGER_AWS_SECRET_KEY in your .env to activate',
        )
      }

      this.client = new SecretsManagerClient({
        region: this.region,
        credentials: {
          accessKeyId: accessKey,
          secretAccessKey: secretKey,
        },
      })

      console.log(`AWS Secrets Manager active in region ${this.region}`)
    } catch (error) {
      console.warn(`AWS Secrets manager failed to start`)

      throw new Error(error)
    }
  }

  public async getSecret(secretId: string): Promise<string> {
    const command = new GetSecretValueCommand({
      SecretId: secretId,
    })

    const response = await this.client.send(command)

    const secretValue = response.SecretString

    return secretValue
  }
}
